// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Metric from "../../resources/data-visualizations/Metric.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Loyalty from "../../modules/Loyalty/Loyalty.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as ValueIndicator from "../../resources/data-visualizations/ValueIndicator.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["fragment AnalyticsPerformanceFragment on GeneralKeyPerformanceIndicators   {\n__typename  \nticketsRevenue  {\n__typename  \nincludingTaxes  \nexcludingTaxes  \n}\n\ninvoicesRevenue  {\n__typename  \nincludingTaxes  \nexcludingTaxes  \n}\n\nglobalRevenue  {\n__typename  \nincludingTaxes  \nexcludingTaxes  \n}\n\nsalesCount  \nsalesIndex  \nshoppingCartAverage  \ntotalAmountOfTaxes  \nproductsSoldCount  \nmargin  \nmarginRate  \nmarkupRate  \ntotalPurchaseCost  \nnewCustomersCount  \nnewCustomersWithLoyaltyCount  \n}\n"]);

function parse(value) {
  let value$1 = value.ticketsRevenue;
  let value$2 = value.invoicesRevenue;
  let value$3 = value.globalRevenue;
  return {
    __typename: value.__typename,
    ticketsRevenue: {
      __typename: value$1.__typename,
      includingTaxes: value$1.includingTaxes,
      excludingTaxes: value$1.excludingTaxes
    },
    invoicesRevenue: {
      __typename: value$2.__typename,
      includingTaxes: value$2.includingTaxes,
      excludingTaxes: value$2.excludingTaxes
    },
    globalRevenue: {
      __typename: value$3.__typename,
      includingTaxes: value$3.includingTaxes,
      excludingTaxes: value$3.excludingTaxes
    },
    salesCount: value.salesCount,
    salesIndex: value.salesIndex,
    shoppingCartAverage: value.shoppingCartAverage,
    totalAmountOfTaxes: value.totalAmountOfTaxes,
    productsSoldCount: value.productsSoldCount,
    margin: value.margin,
    marginRate: value.marginRate,
    markupRate: value.markupRate,
    totalPurchaseCost: value.totalPurchaseCost,
    newCustomersCount: value.newCustomersCount,
    newCustomersWithLoyaltyCount: value.newCustomersWithLoyaltyCount
  };
}

function serialize(value) {
  let value$1 = value.newCustomersWithLoyaltyCount;
  let value$2 = value.newCustomersCount;
  let value$3 = value.totalPurchaseCost;
  let value$4 = value.markupRate;
  let value$5 = value.marginRate;
  let value$6 = value.margin;
  let value$7 = value.productsSoldCount;
  let value$8 = value.totalAmountOfTaxes;
  let value$9 = value.shoppingCartAverage;
  let value$10 = value.salesIndex;
  let value$11 = value.salesCount;
  let value$12 = value.globalRevenue;
  let value$13 = value$12.excludingTaxes;
  let value$14 = value$12.includingTaxes;
  let value$15 = value$12.__typename;
  let globalRevenue = {
    __typename: value$15,
    includingTaxes: value$14,
    excludingTaxes: value$13
  };
  let value$16 = value.invoicesRevenue;
  let value$17 = value$16.excludingTaxes;
  let value$18 = value$16.includingTaxes;
  let value$19 = value$16.__typename;
  let invoicesRevenue = {
    __typename: value$19,
    includingTaxes: value$18,
    excludingTaxes: value$17
  };
  let value$20 = value.ticketsRevenue;
  let value$21 = value$20.excludingTaxes;
  let value$22 = value$20.includingTaxes;
  let value$23 = value$20.__typename;
  let ticketsRevenue = {
    __typename: value$23,
    includingTaxes: value$22,
    excludingTaxes: value$21
  };
  let value$24 = value.__typename;
  return {
    __typename: value$24,
    ticketsRevenue: ticketsRevenue,
    invoicesRevenue: invoicesRevenue,
    globalRevenue: globalRevenue,
    salesCount: value$11,
    salesIndex: value$10,
    shoppingCartAverage: value$9,
    totalAmountOfTaxes: value$8,
    productsSoldCount: value$7,
    margin: value$6,
    marginRate: value$5,
    markupRate: value$4,
    totalPurchaseCost: value$3,
    newCustomersCount: value$2,
    newCustomersWithLoyaltyCount: value$1
  };
}

function verifyArgsAndParse(_AnalyticsPerformanceFragment, value) {
  return parse(value);
}

function verifyName(_fragmentName) {
  
}

let AnalyticsPerformanceFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

let Raw$1 = {};

let query$1 = Client.gql([
  "query AnalyticsOverviewQuery($shopIds: [String!]!, $startDateSelectedPeriod: Datetime!, $endDateSelectedPeriod: Datetime!, $startDateComparisonPeriod: Datetime!, $endDateComparisonPeriod: Datetime!)  {\nindicatorsCurrent: generalKeyPerformanceIndicators(startDate: $startDateSelectedPeriod, endDate: $endDateSelectedPeriod, shopIds: $shopIds)  {\n...AnalyticsPerformanceFragment   \n}\n\nindicatorPrevious: generalKeyPerformanceIndicators(startDate: $startDateComparisonPeriod, endDate: $endDateComparisonPeriod, shopIds: $shopIds)  {\n...AnalyticsPerformanceFragment   \n}\n\n}\n",
  ""
], query);

function parse$1(value) {
  let value$1 = value.indicatorsCurrent;
  let value$2 = value.indicatorPrevious;
  return {
    indicatorsCurrent: parse(value$1),
    indicatorPrevious: parse(value$2)
  };
}

function serialize$1(value) {
  let value$1 = value.indicatorPrevious;
  let indicatorPrevious = serialize(value$1);
  let value$2 = value.indicatorsCurrent;
  let indicatorsCurrent = serialize(value$2);
  return {
    indicatorsCurrent: indicatorsCurrent,
    indicatorPrevious: indicatorPrevious
  };
}

function serializeVariables(inp) {
  let a = inp.shopIds;
  return {
    shopIds: a.map(b => b),
    startDateSelectedPeriod: inp.startDateSelectedPeriod,
    endDateSelectedPeriod: inp.endDateSelectedPeriod,
    startDateComparisonPeriod: inp.startDateComparisonPeriod,
    endDateComparisonPeriod: inp.endDateComparisonPeriod
  };
}

function makeVariables(shopIds, startDateSelectedPeriod, endDateSelectedPeriod, startDateComparisonPeriod, endDateComparisonPeriod, param) {
  return {
    shopIds: shopIds,
    startDateSelectedPeriod: startDateSelectedPeriod,
    endDateSelectedPeriod: endDateSelectedPeriod,
    startDateComparisonPeriod: startDateComparisonPeriod,
    endDateComparisonPeriod: endDateComparisonPeriod
  };
}

let AnalyticsPerformanceIndicatorsQueries_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables
});

let use = include.use;

let AnalyticsPerformanceIndicatorsQueries_refetchQueryDescription = include.refetchQueryDescription;

let AnalyticsPerformanceIndicatorsQueries_useLazy = include.useLazy;

let AnalyticsPerformanceIndicatorsQueries_useLazyWithVariables = include.useLazyWithVariables;

let AnalyticsPerformanceIndicatorsQueries = {
  AnalyticsPerformanceIndicatorsQueries_inner: AnalyticsPerformanceIndicatorsQueries_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: AnalyticsPerformanceIndicatorsQueries_refetchQueryDescription,
  use: use,
  useLazy: AnalyticsPerformanceIndicatorsQueries_useLazy,
  useLazyWithVariables: AnalyticsPerformanceIndicatorsQueries_useLazyWithVariables
};

let Raw$2 = {};

let query$2 = Client.gql(["query AnalyticsShopsInventoryValuationQuery($shopIds: [String!]!)  {\nshopsInventoryValuation(shopIds: $shopIds)  {\n__typename  \ninventoryValuation  \nshop  {\n__typename  \nid  \nname  \n}\n\n}\n\n}\n"]);

function parse$2(value) {
  let value$1 = value.shopsInventoryValuation;
  return {
    shopsInventoryValuation: value$1.map(value => {
      let value$1 = value.shop;
      return {
        __typename: value.__typename,
        inventoryValuation: value.inventoryValuation,
        shop: {
          __typename: value$1.__typename,
          id: value$1.id,
          name: value$1.name
        }
      };
    })
  };
}

function serialize$2(value) {
  let value$1 = value.shopsInventoryValuation;
  let shopsInventoryValuation = value$1.map(value => {
    let value$1 = value.shop;
    let value$2 = value$1.name;
    let value$3 = value$1.id;
    let value$4 = value$1.__typename;
    let shop = {
      __typename: value$4,
      id: value$3,
      name: value$2
    };
    let value$5 = value.inventoryValuation;
    let value$6 = value.__typename;
    return {
      __typename: value$6,
      inventoryValuation: value$5,
      shop: shop
    };
  });
  return {
    shopsInventoryValuation: shopsInventoryValuation
  };
}

function serializeVariables$1(inp) {
  let a = inp.shopIds;
  return {
    shopIds: a.map(b => b)
  };
}

function makeVariables$1(shopIds, param) {
  return {
    shopIds: shopIds
  };
}

let AnalyticsShopsInventoryValuationQuery_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let AnalyticsShopsInventoryValuationQuery_refetchQueryDescription = include$1.refetchQueryDescription;

let AnalyticsShopsInventoryValuationQuery_useLazy = include$1.useLazy;

let AnalyticsShopsInventoryValuationQuery_useLazyWithVariables = include$1.useLazyWithVariables;

let AnalyticsShopsInventoryValuationQuery = {
  AnalyticsShopsInventoryValuationQuery_inner: AnalyticsShopsInventoryValuationQuery_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  refetchQueryDescription: AnalyticsShopsInventoryValuationQuery_refetchQueryDescription,
  use: use$1,
  useLazy: AnalyticsShopsInventoryValuationQuery_useLazy,
  useLazyWithVariables: AnalyticsShopsInventoryValuationQuery_useLazyWithVariables
};

function percentageGrowth(firstValue, secondValue) {
  return (secondValue - firstValue) / Math.abs(firstValue);
}

function getPeriodName(mode) {
  if (mode === "PreviousYearPeriod") {
    return I18n.t("Previous year");
  } else {
    return I18n.t("Previous period");
  }
}

function makeTooltipElement(amount, previousPeriod) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Tooltip.Span.make, {
        text: amount,
        bold: true,
        size: "small"
      }),
      JsxRuntime.jsx(Tooltip.Gap.make, {
        space: "xxsmall"
      }),
      JsxRuntime.jsx(Tooltip.Span.make, {
        text: previousPeriod
      })
    ]
  });
}

function AnalyticsOverviewPage$Progression(props) {
  let comparisonMode = props.mode;
  let percentageGrowth = props.value;
  switch (percentageGrowth.TAG) {
    case "Currency" :
      let previousPeriodValue = percentageGrowth._0;
      let difference = percentageGrowth._1 - previousPeriodValue;
      let formattedDifference = I18n.currencyFormat(undefined, "EUR", 2, 2, difference);
      let formattedAmount = difference > 0 ? "+" + formattedDifference : formattedDifference;
      let formattedPreviousPeriod = getPeriodName(comparisonMode) + " : " + I18n.currencyFormat(undefined, "EUR", 2, 2, previousPeriodValue);
      return makeTooltipElement(formattedAmount, formattedPreviousPeriod);
    case "Percentage" :
      let previousPeriodValue$1 = percentageGrowth._0;
      let difference$1 = percentageGrowth._1 - previousPeriodValue$1;
      let formattedDifference$1 = I18n.percentFormat(undefined, 2, 2, difference$1);
      let formattedAmount$1 = difference$1 > 0 ? "+" + formattedDifference$1 : formattedDifference$1;
      let formattedPreviousPeriod$1 = getPeriodName(comparisonMode) + " : " + I18n.percentFormat(undefined, 2, 2, previousPeriodValue$1);
      return makeTooltipElement(formattedAmount$1, formattedPreviousPeriod$1);
    case "Quantity" :
      let previousPeriodValue$2 = percentageGrowth._0;
      let difference$2 = percentageGrowth._1 - previousPeriodValue$2 | 0;
      let formattedAmount$2 = difference$2 > 0 ? "+" + difference$2.toString() : difference$2.toString();
      let formattedPreviousPeriod$2 = getPeriodName(comparisonMode) + " : " + previousPeriodValue$2.toString();
      return makeTooltipElement(formattedAmount$2, formattedPreviousPeriod$2);
    case "Index" :
      let previousPeriodValue$3 = percentageGrowth._0;
      let difference$3 = percentageGrowth._1 - previousPeriodValue$3;
      let formattedDifference$2 = I18n.decimalFormat(undefined, 2, 2, undefined, difference$3);
      let formattedAmount$3 = difference$3 > 0 ? "+" + formattedDifference$2 : formattedDifference$2;
      let formattedPreviousPeriod$3 = getPeriodName(comparisonMode) + " : " + I18n.decimalFormat(undefined, 2, 2, undefined, previousPeriodValue$3);
      return makeTooltipElement(formattedAmount$3, formattedPreviousPeriod$3);
  }
}

let make = React.memo(AnalyticsOverviewPage$Progression);

let Progression = {
  getPeriodName: getPeriodName,
  makeTooltipElement: makeTooltipElement,
  make: make
};

function AnalyticsOverviewPage$TicketsRevenueMetric(props) {
  let currency = props.currency;
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(ValueIndicator.make, {
          value: {
            NAME: "currency",
            VAL: [
              props.value,
              currency
            ]
          }
        }),
        JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Tickets revenue incl. VAT"),
              variation: "normal",
              size: "xxsmall"
            }),
            JsxRuntime.jsx(ValueIndicator.make, {
              value: {
                NAME: "currency",
                VAL: [
                  props.secondaryValue,
                  currency
                ]
              },
              variant: "compact"
            })
          ],
          space: "xsmall"
        })
      ],
      space: "normal"
    }),
    title: I18n.t("Tickets revenue excl. VAT"),
    loading: props.loading,
    percentageGrowth: props.percentageGrowth,
    tooltip: props.tooltip
  });
}

let TicketsRevenueMetric = {
  make: AnalyticsOverviewPage$TicketsRevenueMetric
};

function AnalyticsOverviewPage$InvoicesRevenueMetric(props) {
  let currency = props.currency;
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(ValueIndicator.make, {
          value: {
            NAME: "currency",
            VAL: [
              props.value,
              currency
            ]
          }
        }),
        JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Invoices revenue incl. VAT"),
              variation: "normal",
              size: "xxsmall"
            }),
            JsxRuntime.jsx(ValueIndicator.make, {
              value: {
                NAME: "currency",
                VAL: [
                  props.secondaryValue,
                  currency
                ]
              },
              variant: "compact"
            })
          ],
          space: "xsmall"
        })
      ],
      space: "normal"
    }),
    title: I18n.t("Invoices revenue excl. VAT"),
    loading: props.loading,
    percentageGrowth: props.percentageGrowth,
    tooltip: props.tooltip
  });
}

let InvoicesRevenueMetric = {
  make: AnalyticsOverviewPage$InvoicesRevenueMetric
};

function AnalyticsOverviewPage$GlobalRevenueMetric(props) {
  let currency = props.currency;
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(ValueIndicator.make, {
          value: {
            NAME: "currency",
            VAL: [
              props.value,
              currency
            ]
          }
        }),
        JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Global revenue incl. VAT"),
              variation: "normal",
              size: "xxsmall"
            }),
            JsxRuntime.jsx(ValueIndicator.make, {
              value: {
                NAME: "currency",
                VAL: [
                  props.secondaryValue,
                  currency
                ]
              },
              variant: "compact"
            })
          ],
          space: "xsmall"
        })
      ],
      space: "normal"
    }),
    title: I18n.t("Global revenue excl. VAT"),
    loading: props.loading,
    percentageGrowth: props.percentageGrowth,
    tooltip: props.tooltip
  });
}

let GlobalRevenueMetric = {
  make: AnalyticsOverviewPage$GlobalRevenueMetric
};

function AnalyticsOverviewPage$MarginMetric(props) {
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsx(ValueIndicator.make, {
      value: {
        NAME: "currency",
        VAL: [
          props.value,
          props.currency
        ]
      }
    }),
    title: I18n.t("Margin"),
    loading: props.loading,
    percentageGrowth: props.percentageGrowth,
    tooltip: props.tooltip
  });
}

let MarginMetric = {
  make: AnalyticsOverviewPage$MarginMetric
};

function AnalyticsOverviewPage$MarginRateMetric(props) {
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsx(ValueIndicator.make, {
      value: {
        NAME: "percent",
        VAL: props.value / 100
      }
    }),
    title: I18n.t("Margin rate"),
    loading: props.loading,
    percentageGrowth: props.percentageGrowth,
    tooltip: props.tooltip
  });
}

let MarginRateMetric = {
  make: AnalyticsOverviewPage$MarginRateMetric
};

function AnalyticsOverviewPage$MarkupRateMetric(props) {
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsx(ValueIndicator.make, {
      value: {
        NAME: "percent",
        VAL: props.value / 100
      }
    }),
    title: I18n.t("Markup rate"),
    loading: props.loading,
    percentageGrowth: props.percentageGrowth,
    tooltip: props.tooltip
  });
}

let MarkupRateMetric = {
  make: AnalyticsOverviewPage$MarkupRateMetric
};

function AnalyticsOverviewPage$TotalAmountOfTaxesMetric(props) {
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsx(ValueIndicator.make, {
      value: {
        NAME: "currency",
        VAL: [
          props.value,
          props.currency
        ]
      }
    }),
    title: I18n.t("Total amount of VAT"),
    loading: props.loading
  });
}

let TotalAmountOfTaxesMetric = {
  make: AnalyticsOverviewPage$TotalAmountOfTaxesMetric
};

function AnalyticsOverviewPage$TotalPurchaseCostMetric(props) {
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsx(ValueIndicator.make, {
      value: {
        NAME: "currency",
        VAL: [
          props.value,
          props.currency
        ]
      }
    }),
    title: I18n.t("Cost of sales"),
    loading: props.loading
  });
}

let TotalPurchaseCostMetric = {
  make: AnalyticsOverviewPage$TotalPurchaseCostMetric
};

function AnalyticsOverviewPage$AverageCartMetric(props) {
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsx(ValueIndicator.make, {
      value: {
        NAME: "currency",
        VAL: [
          props.value,
          props.currency
        ]
      }
    }),
    title: I18n.t("Average cart incl. VAT"),
    loading: props.loading,
    percentageGrowth: props.percentageGrowth,
    tooltip: props.tooltip
  });
}

let AverageCartMetric = {
  make: AnalyticsOverviewPage$AverageCartMetric
};

function AnalyticsOverviewPage$SalesCountMetric(props) {
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsx(ValueIndicator.make, {
      value: {
        NAME: "integer",
        VAL: props.value
      }
    }),
    title: I18n.t("Number of sales"),
    loading: props.loading,
    percentageGrowth: props.percentageGrowth,
    tooltip: props.tooltip
  });
}

let SalesCountMetric = {
  make: AnalyticsOverviewPage$SalesCountMetric
};

function AnalyticsOverviewPage$SalesIndexMetric(props) {
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsx(ValueIndicator.make, {
      value: {
        NAME: "decimal",
        VAL: props.value
      }
    }),
    title: I18n.t("Sales index"),
    loading: props.loading,
    percentageGrowth: props.percentageGrowth,
    tooltip: props.tooltip
  });
}

let SalesIndexMetric = {
  make: AnalyticsOverviewPage$SalesIndexMetric
};

function AnalyticsOverviewPage$SoldProductsMetric(props) {
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsx(ValueIndicator.make, {
      value: {
        NAME: "integer",
        VAL: props.value
      }
    }),
    title: I18n.t("Sold products"),
    loading: props.loading,
    percentageGrowth: props.percentageGrowth,
    tooltip: props.tooltip
  });
}

let SoldProductsMetric = {
  make: AnalyticsOverviewPage$SoldProductsMetric
};

function AnalyticsOverviewPage$NewCustomersMetric(props) {
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsx(ValueIndicator.make, {
      value: {
        NAME: "integer",
        VAL: props.value
      }
    }),
    title: I18n.t("New customers"),
    loading: props.loading,
    percentageGrowth: props.percentageGrowth,
    tooltip: props.tooltip
  });
}

let NewCustomersMetric = {
  make: AnalyticsOverviewPage$NewCustomersMetric
};

function AnalyticsOverviewPage$NewCustomersWithLoyaltyMetric(props) {
  return JsxRuntime.jsx(Metric.make, {
    children: JsxRuntime.jsx(ValueIndicator.make, {
      value: {
        NAME: "integer",
        VAL: props.value
      }
    }),
    title: I18n.t("New customers with loyalty"),
    loading: props.loading,
    percentageGrowth: props.percentageGrowth,
    tooltip: props.tooltip
  });
}

let NewCustomersWithLoyaltyMetric = {
  make: AnalyticsOverviewPage$NewCustomersWithLoyaltyMetric
};

function AnalyticsOverviewPage$InventoryValuationMetric(props) {
  let __disabled = props.disabled;
  let disabled = __disabled !== undefined ? __disabled : false;
  let tooltip = disabled ? I18n.t("The stock value is computed only on today's date") : undefined;
  return JsxRuntime.jsx(Metric.make, {
    children: disabled ? JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("No data to display for the selected period"),
        variation: "normal"
      }) : JsxRuntime.jsx(ValueIndicator.make, {
        value: {
          NAME: "currency",
          VAL: [
            props.value,
            props.currency
          ]
        }
      }),
    title: I18n.t("Inventory Valuation"),
    loading: props.loading,
    tooltip: tooltip
  });
}

let InventoryValuationMetric = {
  make: AnalyticsOverviewPage$InventoryValuationMetric
};

function make$1(state, action) {
  if (action.TAG === "SelectedPeriodChanged") {
    let dateRange = action._0;
    let endDate = dateRange[1];
    let startDate = dateRange[0];
    let previousPeriod = DateHelpers.getPreviousPeriod(startDate, endDate);
    let previousYearPeriod = DateHelpers.getPreviousYearPeriod(startDate, endDate);
    let match = state.comparisonMode;
    let comparisonPeriod;
    comparisonPeriod = match === "PreviousYearPeriod" ? previousYearPeriod : previousPeriod;
    return {
      selectedPeriod: dateRange,
      comparisonPeriod: comparisonPeriod,
      comparisonMode: state.comparisonMode,
      previousYearPeriod: previousYearPeriod,
      previousPeriod: previousPeriod
    };
  }
  let comparisonMode = action._0;
  let comparisonPeriod$1;
  comparisonPeriod$1 = comparisonMode === "PreviousYearPeriod" ? state.previousYearPeriod : state.previousPeriod;
  return {
    selectedPeriod: state.selectedPeriod,
    comparisonPeriod: comparisonPeriod$1,
    comparisonMode: comparisonMode,
    previousYearPeriod: state.previousYearPeriod,
    previousPeriod: state.previousPeriod
  };
}

let Reducer = {
  make: make$1
};

let now = new Date();

let initialStartDate = DateHelpers.startOfDay(now);

let initialEndDate = DateHelpers.endOfDay(now);

function AnalyticsOverviewPage(props) {
  let scope = Auth.useScope();
  let organisationAccount;
  organisationAccount = scope.TAG === "Organisation";
  let scopeShops;
  if (scope.TAG === "Organisation") {
    let shop = scope.activeShop;
    scopeShops = shop !== undefined ? [shop] : scope.shops;
  } else {
    scopeShops = [scope._0];
  }
  let shopIds = scopeShops.map(shop => shop.id);
  let loyaltyEnabled = Loyalty.isAddonActivatedInAny(scopeShops);
  let match = React.useReducer(make$1, {
    selectedPeriod: [
      initialStartDate,
      initialEndDate
    ],
    comparisonPeriod: DateHelpers.getPreviousPeriod(initialStartDate, initialEndDate),
    comparisonMode: "PreviousYearPeriod",
    previousYearPeriod: DateHelpers.getPreviousYearPeriod(initialStartDate, initialEndDate),
    previousPeriod: DateHelpers.getPreviousPeriod(initialStartDate, initialEndDate)
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.previousPeriod;
  let endDateComparisonPeriodPreviousPeriod = match$1[1];
  let startDateComparisonPeriodPreviousPeriod = match$1[0];
  let match$2 = state.previousYearPeriod;
  let endDateComparisonPeriodPreviousYear = match$2[1];
  let startDateComparisonPeriodPreviousYear = match$2[0];
  let match$3 = state.selectedPeriod;
  let endDateSelectedPeriod = match$3[1];
  let startDateSelectedPeriod = match$3[0];
  let match$4 = state.comparisonPeriod;
  let isDateRangeDifferentThanToday = !(DateHelpers.isSameDay(initialStartDate, startDateSelectedPeriod) && DateHelpers.isSameDay(initialEndDate, endDateSelectedPeriod));
  let analyticsPerformanceIndicatorsQueriesResult = AsyncResult.mapError(AsyncResult.mapOk(ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, "CacheAndNetwork", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, makeVariables(shopIds, Scalar.Datetime.serialize(startDateSelectedPeriod), Scalar.Datetime.serialize(endDateSelectedPeriod), Scalar.Datetime.serialize(match$4[0]), Scalar.Datetime.serialize(match$4[1]), undefined))), data => data), param => {});
  let analyticsShopsInventoryValuationQueryResult = AsyncResult.mapError(AsyncResult.mapOk(ApolloHelpers.queryResultToAsyncResult(use$1(undefined, undefined, undefined, undefined, "CacheAndNetwork", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    shopIds: shopIds
  })), param => param.shopsInventoryValuation), param => {});
  let renderHeaderActions = () => {
    let previousYearItem_1 = I18n.t("Previous year");
    let previousYearItem = {
      TAG: "Option",
      key: "select_previous_year",
      label: previousYearItem_1,
      value: "PreviousYearPeriod"
    };
    let previousPeriodItem_1 = I18n.t("Previous period");
    let previousPeriodItem = {
      TAG: "Option",
      key: "select_previous_period",
      label: previousPeriodItem_1,
      value: "PreviousPeriod"
    };
    return JsxRuntime.jsxs(Inline.make, {
      children: [
        organisationAccount ? JsxRuntime.jsx(Auth.SelectShopFilter.make, {}) : null,
        organisationAccount ? JsxRuntime.jsx(CanarySeparator.make, {}) : null,
        JsxRuntime.jsx(SelectDateRangeFilter.make, {
          value: state.selectedPeriod,
          placeholder: I18n.t("Select a period"),
          hideResetButton: true,
          onChange: selectedDateRange => Stdlib_Option.forEach(selectedDateRange, dateRange => dispatch({
            TAG: "SelectedPeriodChanged",
            _0: dateRange
          })),
          triggerLabelDisplay: "showPreset"
        }),
        JsxRuntime.jsx(Select.make, {
          label: I18n.t("Compare period to"),
          preset: "filter",
          renderItem: param => {
            let item = param.item;
            if (item.TAG !== "Option") {
              return null;
            }
            let description;
            description = item.value === "PreviousYearPeriod" ? I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, startDateComparisonPeriodPreviousYear) + " - " + I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, endDateComparisonPeriodPreviousYear) : I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, startDateComparisonPeriodPreviousPeriod) + " - " + I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, endDateComparisonPeriodPreviousPeriod);
            return JsxRuntime.jsxs("span", {
              children: [
                item.label,
                JsxRuntime.jsx("span", {
                  children: "\n" + description,
                  style: {
                    color: "#797885"
                  }
                })
              ],
              style: {
                display: "block",
                lineHeight: "18px",
                padding: "10px 0"
              }
            });
          },
          sections: [{
              items: [
                previousYearItem,
                previousPeriodItem
              ]
            }],
          value: {
            TAG: "Single",
            _0: state.comparisonMode
          },
          onChange: change => {
            if (change.TAG === "Single") {
              return dispatch({
                TAG: "ComparisonModeChanged",
                _0: change._0
              });
            }
          }
        })
      ],
      space: "small"
    });
  };
  let tmp;
  let exit = 0;
  let data;
  if (typeof analyticsPerformanceIndicatorsQueriesResult !== "object") {
    exit = 1;
  } else if (analyticsPerformanceIndicatorsQueriesResult.TAG === "Reloading") {
    let data$1 = analyticsPerformanceIndicatorsQueriesResult._0;
    if (data$1.TAG === "Ok") {
      data = data$1._0;
      exit = 2;
    } else {
      exit = 1;
    }
  } else {
    let data$2 = analyticsPerformanceIndicatorsQueriesResult._0;
    if (data$2.TAG === "Ok") {
      data = data$2._0;
      exit = 2;
    } else {
      tmp = JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      });
    }
  }
  switch (exit) {
    case 1 :
      tmp = JsxRuntime.jsx(Placeholder.make, {
        status: "Loading"
      });
      break;
    case 2 :
      let loading = AsyncResult.isReloading(analyticsPerformanceIndicatorsQueriesResult);
      let tmp$1;
      let exit$1 = 0;
      let shopsInventoryValuation;
      if (typeof analyticsShopsInventoryValuationQueryResult !== "object") {
        exit$1 = 3;
      } else if (analyticsShopsInventoryValuationQueryResult.TAG === "Reloading") {
        let shopsInventoryValuation$1 = analyticsShopsInventoryValuationQueryResult._0;
        if (shopsInventoryValuation$1.TAG === "Ok") {
          shopsInventoryValuation = shopsInventoryValuation$1._0;
          exit$1 = 4;
        } else {
          exit$1 = 3;
        }
      } else {
        let shopsInventoryValuation$2 = analyticsShopsInventoryValuationQueryResult._0;
        if (shopsInventoryValuation$2.TAG === "Ok") {
          shopsInventoryValuation = shopsInventoryValuation$2._0;
          exit$1 = 4;
        } else {
          tmp$1 = null;
        }
      }
      switch (exit$1) {
        case 3 :
          tmp$1 = JsxRuntime.jsx(AnalyticsOverviewPage$InventoryValuationMetric, {
            loading: true,
            value: 0,
            currency: "EUR"
          });
          break;
        case 4 :
          tmp$1 = JsxRuntime.jsx(AnalyticsOverviewPage$InventoryValuationMetric, {
            loading: AsyncResult.isReloading(analyticsShopsInventoryValuationQueryResult),
            value: Stdlib_Array.reduce(shopsInventoryValuation, 0, (acc, next) => acc + next.inventoryValuation),
            currency: "EUR",
            disabled: isDateRangeDifferentThanToday
          });
          break;
      }
      tmp = JsxRuntime.jsxs(Group.make, {
        children: [
          JsxRuntime.jsx(AnalyticsOverviewPage$TicketsRevenueMetric, {
            loading: loading,
            value: data.indicatorsCurrent.ticketsRevenue.excludingTaxes,
            secondaryValue: data.indicatorsCurrent.ticketsRevenue.includingTaxes,
            currency: "EUR",
            percentageGrowth: percentageGrowth(data.indicatorPrevious.ticketsRevenue.excludingTaxes, data.indicatorsCurrent.ticketsRevenue.excludingTaxes),
            tooltip: JsxRuntime.jsx(make, {
              value: {
                TAG: "Currency",
                _0: data.indicatorPrevious.ticketsRevenue.excludingTaxes,
                _1: data.indicatorsCurrent.ticketsRevenue.excludingTaxes
              },
              mode: state.comparisonMode
            })
          }),
          JsxRuntime.jsx(AnalyticsOverviewPage$InvoicesRevenueMetric, {
            loading: loading,
            value: data.indicatorsCurrent.invoicesRevenue.excludingTaxes,
            secondaryValue: data.indicatorsCurrent.invoicesRevenue.includingTaxes,
            currency: "EUR",
            percentageGrowth: percentageGrowth(data.indicatorPrevious.invoicesRevenue.excludingTaxes, data.indicatorsCurrent.invoicesRevenue.excludingTaxes),
            tooltip: JsxRuntime.jsx(make, {
              value: {
                TAG: "Currency",
                _0: data.indicatorPrevious.invoicesRevenue.excludingTaxes,
                _1: data.indicatorsCurrent.invoicesRevenue.excludingTaxes
              },
              mode: state.comparisonMode
            })
          }),
          JsxRuntime.jsx(AnalyticsOverviewPage$GlobalRevenueMetric, {
            loading: loading,
            value: data.indicatorsCurrent.globalRevenue.excludingTaxes,
            secondaryValue: data.indicatorsCurrent.globalRevenue.includingTaxes,
            currency: "EUR",
            percentageGrowth: percentageGrowth(data.indicatorPrevious.globalRevenue.excludingTaxes, data.indicatorsCurrent.globalRevenue.excludingTaxes),
            tooltip: JsxRuntime.jsx(make, {
              value: {
                TAG: "Currency",
                _0: data.indicatorPrevious.globalRevenue.excludingTaxes,
                _1: data.indicatorsCurrent.globalRevenue.excludingTaxes
              },
              mode: state.comparisonMode
            })
          }),
          JsxRuntime.jsx(AnalyticsOverviewPage$MarginMetric, {
            loading: loading,
            value: data.indicatorsCurrent.margin,
            currency: "EUR",
            percentageGrowth: percentageGrowth(data.indicatorPrevious.margin, data.indicatorsCurrent.margin),
            tooltip: JsxRuntime.jsx(make, {
              value: {
                TAG: "Currency",
                _0: data.indicatorPrevious.margin,
                _1: data.indicatorsCurrent.margin
              },
              mode: state.comparisonMode
            })
          }),
          JsxRuntime.jsx(AnalyticsOverviewPage$MarginRateMetric, {
            loading: loading,
            value: data.indicatorsCurrent.marginRate,
            percentageGrowth: percentageGrowth(data.indicatorPrevious.marginRate, data.indicatorsCurrent.marginRate),
            tooltip: JsxRuntime.jsx(make, {
              value: {
                TAG: "Percentage",
                _0: data.indicatorPrevious.marginRate / 100,
                _1: data.indicatorsCurrent.marginRate / 100
              },
              mode: state.comparisonMode
            })
          }),
          JsxRuntime.jsx(AnalyticsOverviewPage$MarkupRateMetric, {
            loading: loading,
            value: data.indicatorsCurrent.markupRate,
            percentageGrowth: percentageGrowth(data.indicatorPrevious.markupRate, data.indicatorsCurrent.markupRate),
            tooltip: JsxRuntime.jsx(make, {
              value: {
                TAG: "Percentage",
                _0: data.indicatorPrevious.markupRate / 100,
                _1: data.indicatorsCurrent.markupRate / 100
              },
              mode: state.comparisonMode
            })
          }),
          JsxRuntime.jsx(AnalyticsOverviewPage$TotalPurchaseCostMetric, {
            loading: loading,
            value: data.indicatorsCurrent.totalPurchaseCost,
            currency: "EUR"
          }),
          JsxRuntime.jsx(AnalyticsOverviewPage$TotalAmountOfTaxesMetric, {
            loading: loading,
            value: data.indicatorsCurrent.totalAmountOfTaxes,
            currency: "EUR"
          }),
          JsxRuntime.jsx(AnalyticsOverviewPage$AverageCartMetric, {
            loading: loading,
            value: data.indicatorsCurrent.shoppingCartAverage,
            currency: "EUR",
            percentageGrowth: percentageGrowth(data.indicatorPrevious.shoppingCartAverage, data.indicatorsCurrent.shoppingCartAverage),
            tooltip: JsxRuntime.jsx(make, {
              value: {
                TAG: "Currency",
                _0: data.indicatorPrevious.shoppingCartAverage,
                _1: data.indicatorsCurrent.shoppingCartAverage
              },
              mode: state.comparisonMode
            })
          }),
          JsxRuntime.jsx(AnalyticsOverviewPage$SalesCountMetric, {
            loading: loading,
            value: data.indicatorsCurrent.salesCount,
            percentageGrowth: percentageGrowth(data.indicatorPrevious.salesCount, data.indicatorsCurrent.salesCount),
            tooltip: JsxRuntime.jsx(make, {
              value: {
                TAG: "Quantity",
                _0: data.indicatorPrevious.salesCount,
                _1: data.indicatorsCurrent.salesCount
              },
              mode: state.comparisonMode
            })
          }),
          JsxRuntime.jsx(AnalyticsOverviewPage$SalesIndexMetric, {
            loading: loading,
            value: data.indicatorsCurrent.salesIndex,
            percentageGrowth: percentageGrowth(data.indicatorPrevious.salesIndex, data.indicatorsCurrent.salesIndex),
            tooltip: JsxRuntime.jsx(make, {
              value: {
                TAG: "Index",
                _0: data.indicatorPrevious.salesIndex,
                _1: data.indicatorsCurrent.salesIndex
              },
              mode: state.comparisonMode
            })
          }),
          JsxRuntime.jsx(AnalyticsOverviewPage$SoldProductsMetric, {
            loading: loading,
            value: data.indicatorsCurrent.productsSoldCount,
            percentageGrowth: percentageGrowth(data.indicatorPrevious.productsSoldCount, data.indicatorsCurrent.productsSoldCount),
            tooltip: JsxRuntime.jsx(make, {
              value: {
                TAG: "Quantity",
                _0: data.indicatorPrevious.productsSoldCount,
                _1: data.indicatorsCurrent.productsSoldCount
              },
              mode: state.comparisonMode
            })
          }),
          JsxRuntime.jsx(AnalyticsOverviewPage$NewCustomersMetric, {
            loading: loading,
            value: data.indicatorsCurrent.newCustomersCount,
            percentageGrowth: percentageGrowth(data.indicatorPrevious.newCustomersCount, data.indicatorsCurrent.newCustomersCount),
            tooltip: JsxRuntime.jsx(make, {
              value: {
                TAG: "Quantity",
                _0: data.indicatorPrevious.newCustomersCount,
                _1: data.indicatorsCurrent.newCustomersCount
              },
              mode: state.comparisonMode
            })
          }),
          loyaltyEnabled ? JsxRuntime.jsx(AnalyticsOverviewPage$NewCustomersWithLoyaltyMetric, {
              loading: loading,
              value: data.indicatorsCurrent.newCustomersWithLoyaltyCount,
              percentageGrowth: percentageGrowth(data.indicatorPrevious.newCustomersWithLoyaltyCount, data.indicatorsCurrent.newCustomersWithLoyaltyCount),
              tooltip: JsxRuntime.jsx(make, {
                value: {
                  TAG: "Quantity",
                  _0: data.indicatorPrevious.newCustomersWithLoyaltyCount,
                  _1: data.indicatorsCurrent.newCustomersWithLoyaltyCount
                },
                mode: state.comparisonMode
              })
            }) : null,
          tmp$1,
          JsxRuntime.jsx("div", {}),
          JsxRuntime.jsx("div", {})
        ],
        grid: [
          "33%",
          "33%",
          "33%"
        ],
        spaceX: "normal",
        spaceY: "large"
      });
      break;
  }
  return JsxRuntime.jsx(Page.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: tmp,
      spaceTop: "xlarge",
      grow: true
    }),
    variation: "compact",
    title: I18n.t("General performances"),
    renderHeaderActions: renderHeaderActions
  });
}

let make$2 = React.memo(AnalyticsOverviewPage);

let getPreviousYearPeriod = DateHelpers.getPreviousYearPeriod;

let getPreviousPeriod = DateHelpers.getPreviousPeriod;

export {
  AnalyticsPerformanceFragment,
  AnalyticsPerformanceIndicatorsQueries,
  AnalyticsShopsInventoryValuationQuery,
  percentageGrowth,
  Progression,
  TicketsRevenueMetric,
  InvoicesRevenueMetric,
  GlobalRevenueMetric,
  MarginMetric,
  MarginRateMetric,
  MarkupRateMetric,
  TotalAmountOfTaxesMetric,
  TotalPurchaseCostMetric,
  AverageCartMetric,
  SalesCountMetric,
  SalesIndexMetric,
  SoldProductsMetric,
  NewCustomersMetric,
  NewCustomersWithLoyaltyMetric,
  InventoryValuationMetric,
  getPreviousYearPeriod,
  getPreviousPeriod,
  Reducer,
  now,
  initialStartDate,
  initialEndDate,
  make$2 as make,
}
/* query Not a pure module */
